import { Currency } from '../../court-pricing/dto/court-pricing-rule.dto';
import { OrganizationLocationDto } from '../../location/dto/location.dto';
import { CourtAvailabilityTemplateDto } from './court-availability-template.dto';
import { CourtAvailabilityDto } from './court-availability.dto';

export type CourtDto = {
  id: number;
  name: string;
  availabilities: CourtAvailabilityDto[];
  sports?: SportType[];
  defaultHourlyPrice: number;
  defaultHourlyPriceCurrency: Currency;
  defaultHourlyPriceDuration: number;
  location: OrganizationLocationDto;
  availabilityTemplates: CourtAvailabilityTemplateDto[];
  isOutdoor?: boolean;
  isComposite?: boolean;
  /** MYS-73: lower number = preferred when auto-assigning a coaching court. Null/undefined = unranked. */
  coachingPriority?: number | null;
  parentCourts?: Array<{
    id: number;
    name: string;
  }>;
  subCourts?: Array<{
    id: number;
    name: string;
  }>;
};

export enum SportType {
  FITNESS = 'Fitness',
  PADEL = 'Padel',
  PADEL1V1 = 'Padel 1v1',
  TENNIS = 'Tennis',
  BASKETBALL = 'Basketball',
  BASKETBALL1V1 = 'Basketball 1v1',
  VOLLEYBALL = 'Volleyball',
  BADMINTON = 'Badminton',
  FOOTBALL = 'Football',
  BEACH_RUGBY = 'Beach Rugby',
  BEACH_SOCCER = 'Beach Soccer',
  BEACH_TENNIS = 'Beach Tennis',
  BEACH_VOLLEYBALL = 'Beach Volleyball',
  BEACH_BADMINTON = 'Beachminton',
  GOLF = 'Golf',
  PICKLE_BALL = 'Pickleball',
  SANDBALL = 'Sandball',
  SQUASH = 'Squash',
  TENNIS_DE_TABLE = 'Tennis de table',
  TOUCH_TENNIS = 'Touch Tennis',
}

/** So clients that default to "first sport" get Padel when it's offered. */
export function sortSportsWithPadelFirst(
  sports?: SportType[],
): SportType[] | undefined {
  if (!sports?.length) return sports;
  if (!sports.includes(SportType.PADEL)) return sports;
  return [SportType.PADEL, ...sports.filter((s) => s !== SportType.PADEL)];
}
